import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";

const ErrorScreen = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      backgroundColor: '#ffffff',
      color: '#721c24',
      fontFamily: 'sans-serif',
      padding: 20,
      textAlign: 'center'
    }}>
      <h1>⚠️ {t("error")}</h1>
      <p>{message}</p>
      <small>{t("errorMessage")}</small>
    </div>
  )
};

export default ErrorScreen;
